import { Attributes, DateUtils, Misc, Model, Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class LiabilityWriteUpCriteria extends Model.CriteriaBase {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public entityId: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    @Attributes.Nullable()
    public investorId: number | null = null;

    @Rules.Required()
    public signatory1: number | null = null;

    @Rules.Required()
    public signatory2: number | null = null;

    @Rules.Required()
    public signatory3: number | null = null;

    // Client only properties / methods

    public investorName: string | null = null;

    public signatoryName1: number | null = null;

    public signatoryName2: number | null = null;

    public signatoryName3: number | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Liability Writeup Criteria";
    }
}